import { render, staticRenderFns } from "./videowall-item.vue?vue&type=template&id=ddddfb46&"
import script from "./videowall-item.vue?vue&type=script&lang=js&"
export * from "./videowall-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports